export default function formatObjectToSearchParams(obj: object) {
  const formatted = Object.entries(obj)
    .filter(([, value]) => {
      return !(Array.isArray(value) && value.length === 0) && !!value;
    })
    .map(([key, value]) => `${key}=${String(value)}`)
    .join('&');

  return formatted?.length ? `?${formatted}` : '';
}
